import {useTransition} from '@yandex-delivery/blocks'
import type {ServerError} from '@yandex-delivery/core/utils/network'
import type {Optional} from '@yandex-delivery/types'

import {fetchOffersInfoDeprecated} from 'src/shared/api'
import type {NddClaimOffersResponse, NddClaimParcel, SourcePointDeliveryMethod} from 'src/shared/types'
import {DestinationPointDeliveryMethod} from 'src/shared/types'

type UseFetchOffersInfoHandlerProps = {
  sourcePointStationId?: string
  sourcePointDropOffPointId?: string
  sourcePointDeliveryMethod?: SourcePointDeliveryMethod
  destinationPointPickupPointId?: string
  places: NddClaimParcel[]
  pointType: unknown
}

export function useFetchOffersInfo() {
  const [{payload: offersInfo, isPending: isOffersInfoPending}, startTransition] = useTransition<
    Optional<NddClaimOffersResponse>,
    ServerError
  >(undefined, {
    key: 'offers-info',
    shouldShowBaseError: false,
  })

  function fetchOffersInfoHandler(props: UseFetchOffersInfoHandlerProps) {
    const {
      sourcePointDropOffPointId,
      sourcePointStationId,
      pointType,
      sourcePointDeliveryMethod,
      destinationPointPickupPointId,
      places,
    } = props

    startTransition(() => {
      if (sourcePointStationId === undefined && sourcePointDropOffPointId === undefined) {
        return Promise.resolve(undefined)
      }

      if (pointType === DestinationPointDeliveryMethod.PickUpPoint) {
        return Promise.resolve(undefined)
      }

      return fetchOffersInfoDeprecated(
        {
          source: {
            platform_station_id:
              sourcePointDeliveryMethod === 'station' ? sourcePointStationId : sourcePointDropOffPointId,
          },
          destination: {
            platform_station_id: destinationPointPickupPointId,
          },
          places,
        },
        {
          last_mile_policy: '',
        },
      )
    })
  }

  return {
    isOffersInfoPending,
    offersInfo,
    fetchOffersInfoHandler,
  }
}
